//
//
//
//
//
//
//
//

export default {
  name: "App",
  data(){
    return {
      blackList:['schoolDetail','popdetais']
    }
  }
  
};



// WEBPACK FOOTER //
// ./src/App.vue